import React from "react";
import { connect } from "react-redux";

import { faSave } from "@fortawesome/pro-solid-svg-icons/faSave";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Col from "antd/es/col";
import Row from "antd/es/row";
import { useIntl } from "react-intl";

import ImportConfig from "@mapmycustomers/shared/types/imports/ImportConfig";
import { Button } from "@mapmycustomers/ui";

import { isUpdatingConfig } from "@app/scene/settings/component/Imports/store/selectors";
import { RootState } from "@app/store/rootReducer";
import layout from "@app/styles/layout";

import styles from "./ConfigCard.module.scss";

interface Props {
  config?: ImportConfig;
  isSavingConfig: boolean;
  onCreateNewConfig: () => void;
  onUpdateConfig: () => void;
}

const ConfigModifiedCard: React.FC<Props> = ({
  config,
  isSavingConfig,
  onCreateNewConfig,
  onUpdateConfig,
}) => {
  const intl = useIntl();

  return (
    <Row
      align="middle"
      className={styles.content}
      gutter={layout.spacerM}
      justify="space-between"
      wrap={false}
    >
      <Col>
        {config
          ? intl.formatMessage(
              {
                id: "settings.newImports.config.bar.modified.title.whenHasConfig",
                defaultMessage: `You’ve made modifications to <b>"{name}"</b>. To avoid losing your work, save your changes or save as a new matching.`,
                description: "Text of import config info block with selected config",
              },
              {
                b: (text) => <b>{text}</b>,
                name: config.name,
              }
            )
          : intl.formatMessage({
              id: "settings.newImports.config.bar.modified.title",
              defaultMessage: "Speed up your next import by saving this field matching",
              description: "Text of import config info block",
            })}
      </Col>
      <Col flex="1 0 auto">
        <Row gutter={layout.spacerM} justify="end">
          <Col>
            <Button
              leftIcon={<FontAwesomeIcon icon={faSave} />}
              onClick={onCreateNewConfig}
              type={config ? "link" : "primary"}
            >
              {config
                ? intl.formatMessage({
                    id: "settings.newImports.config.bar.modified.saveAsNewMatchingButton",
                    defaultMessage: "Save as a new matching",
                    description:
                      "Text of import config info block save matching button with selected config",
                  })
                : intl.formatMessage({
                    id: "settings.newImports.config.bar.modified.updateConfigButton",
                    defaultMessage: "Save matching",
                    description: "Text of import config info block save matching button",
                  })}
            </Button>
          </Col>
          {config && (
            <Col>
              <Button
                leftIcon={<FontAwesomeIcon icon={faSave} />}
                loading={isSavingConfig}
                onClick={onUpdateConfig}
                type="primary"
              >
                {intl.formatMessage({
                  id: "settings.newImports.config.bar.modified.createConfigButton",
                  defaultMessage: "Save changes",
                  description: "Text of import config info block save exists matching button",
                })}
              </Button>
            </Col>
          )}
        </Row>
      </Col>
    </Row>
  );
};

const mapStateToProps = (state: RootState) => ({
  isSavingConfig: isUpdatingConfig(state),
});

export default connect(mapStateToProps)(ConfigModifiedCard);
